import React from "react";
import { Helmet } from "react-helmet-async";

export default function NavbarSEO() {
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "Madeshwara Ambulance Services",
    url: "https://madeshwaraambulance.com",  // 🔧 Replace with your real domain
    logo: "https://madeshwaraambulance.com/logo.png",
    sameAs: [
      "https://www.facebook.com/madeshwaraambulance",
      "https://www.instagram.com/madeshwaraambulance"
    ],
    contactPoint: [
      {
        "@type": "ContactPoint",
        telephone: "+91-9845974238",
        contactType: "Customer Service",
        areaServed: "IN",
        availableLanguage: ["English", "Kannada"]
      }
    ]
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    name: "Madeshwara Ambulance Service",
    image: "https://madeshwaraambulance.com/logo.png",
    "@id": "https://madeshwaraambulance.com",
    url: "https://madeshwaraambulance.com",
    telephone: "+91-9845974238",
    "email": "madeshwaraa@gmail.com",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "No.9/8, Near Swimming Pool, 1st Main Road, 1st Block East, Byrasandra, Jayanagar-560011",
      "addressLocality": "Bangalore",
      "addressRegion": "Karnataka",
      "postalCode": "560011",
      "addressCountry": "IN"
    },
    geo: {
      "@type": "GeoCoordinates",
      latitude: "13.0541",
      longitude: "77.6140"
    },
    openingHoursSpecification: [
      {
        "@type": "OpeningHoursSpecification",
        dayOfWeek: [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
          "Sunday"
        ],
        opens: "00:00",
        closes: "23:59"
      }
    ],
    priceRange: "$$",
    sameAs: [
      "https://www.facebook.com/madeshwaraambulance",
      "https://www.instagram.com/madeshwaraambulance"
    ]
  };

  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "Madeshwara Ambulance",
    url: "https://madeshwaraambulance.com",
    potentialAction: {
      "@type": "SearchAction",
      target: "https://madeshwaraambulance.com/search?query={search_term_string}",
      "query-input": "required name=search_term_string"
    }
  };

  return (
    <Helmet>
      {/* ✅ Basic SEO Meta Tags */}
      <title>Madeshwara Ambulance | 24/7 Emergency Medical Service</title>
      <meta
        name="description"
        content="Madeshwara Ambulance offers 24/7 emergency and non-emergency ambulance services in Bangalore and nearby areas. Fast, safe, and affordable transport with trained staff."
      />
      <meta name="keywords" content="ambulance service, emergency ambulance Bangalore, Madeshwara Ambulance, 24/7 ambulance, medical transport" />
      <meta name="author" content="Madeshwara Ambulance" />
      <meta property="og:title" content="Madeshwara Ambulance | 24/7 Emergency Medical Service" />
      <meta property="og:description" content="Reliable ambulance service in Bangalore. Call 9845974238 for emergency help now!" />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://madeshwaraambulance.com" />
      <meta property="og:image" content="https://madeshwaraambulance.com/logo.png" />
      <meta name="twitter:card" content="summary_large_image" />

      {/* ✅ Structured Data (JSON-LD) */}
      <script type="application/ld+json">
        {JSON.stringify(organizationSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(localBusinessSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(websiteSchema)}
      </script>
    </Helmet>
  );
}
